export const environment = {
  production: import.meta.env.PROD,
  // Use relative path in dev mode to leverage Vite's proxy (avoids CORS)
  // In production builds, this will be replaced with the actual API URL
  apiUrl: import.meta.env.DEV ? '/api' : import.meta.env.VITE_API_URL || 'http://localhost:3000',
  awsRegion: import.meta.env.VITE_AWS_REGION || 'ap-southeast-2',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  cognitoRedirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN || window.location.origin + '/',
  cognitoRedirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT || window.location.origin + '/',
};
